// extracted by mini-css-extract-plugin
module.exports = {"slide":"QuoteCollection-module--slide--2-Yfv","slideItem":"QuoteCollection-module--slideItem--10FGr"};